/**
 * Tabs 组件的 emit 事件声明
 */
export const tabsEmits = [
  /** 切换标签时触发 */
  'change',
  /** 点击标签时触发 */
  'click',
  /** 当前选中标签索引变化时触发 (Vue 3) */
  'update:modelValue',
  /** 当前选中标签索引变化时触发 (Vue 2) */
  'input',
  /** 标签栏滚动时触发 */
  'scroll',
  /** 点击被禁用的标签时触发 */
  'disabled',
];

/**
 * TabItem 组件的 emit 事件声明
 */
export const tabItemEmits = [
  /** 点击标签时触发 */
  'click',
];

